import { registerDecorator, isEmail, ValidationOptions } from 'class-validator';

export const IsEmailOrKakaoStyleAccount = (options?: ValidationOptions) => {
  return (object: object, propertyName: string) => {
    registerDecorator({
      name: 'isEmailOrKakaoStyleAccount',
      target: object.constructor,
      propertyName,
      options,
      validator: {
        validate(value: any) {
          return isEmail(value) || /kakaostyle.com$/.test(value);
        },
      },
    });
  };
};
